import { render, staticRenderFns } from "./NavBar.vue?vue&type=template&id=021a65b4&scoped=true&"
import script from "./NavBar.vue?vue&type=script&lang=ts&"
export * from "./NavBar.vue?vue&type=script&lang=ts&"
import style0 from "./NavBar.vue?vue&type=style&index=0&id=021a65b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021a65b4",
  null
  
)

export default component.exports